export default "__VITE_ASSET__BMZmiLOQ__"